// The MIT License (MIT)
//
// Copyright (c) 2022-2023 Doist Inc.
//
//     Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
//     The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
//     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
//     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// Inspired by https://github.com/Doist/typist/blob/main/src/extensions/rich-text/rich-text-link.ts


import Link from '@tiptap/extension-link'
import { InputRule, markInputRule } from '@tiptap/core'
import './link.css';


const inputRegex = /(?:^|\s)\[([^\]]*)?\]\((\S+)(?: ["“](.+)["”])?\) $/i


function linkInputRule(config: Parameters<typeof markInputRule>[0]) {
    const defaultMarkInputRule = markInputRule(config)

    return new InputRule({
        find: config.find,
        handler(props) {
            const { tr } = props.state

            defaultMarkInputRule.handler(props)
            tr.setMeta('preventAutolink', true)
        },
    })
}


export default Link.extend({
    addKeyboardShortcuts() {
        return {
            'Mod-Space': ({editor}) => {
                // @ts-ignore
                const href = document.getSelection()!.anchorNode!.parentElement!.href
                if (href) {
                    window.open(href, '_blank')
                    return true
                }
                return false
            },
        }
    },
    addInputRules() {
        return [
            linkInputRule({
                find: inputRegex,
                type: this.type,

                // We need to use `pop()` to remove the last capture groups from the match to
                // satisfy Tiptap's `markPasteRule` expectation of having the content as the last
                // capture group in the match (this makes the attribute order important)
                getAttributes(match) {
                    return {
                        title: match.pop()?.trim(),
                        href: match.pop()?.trim(),
                    }
                },
            }),
        ]
    },
})